import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useContentLanguages } from "@common/composable/useMetaDataStore";
import { BaseCatalog, CatalogNode } from "@medapro-types/common/common";
import { Branch, Leaf, MultiLevelNavigationConfirmModel } from "@medapro-types/common/components/MultiLevelNavigation";
import catalogsApi from "@services/catalogs.js";
import { computed, reactive } from "vue";
import MultiLevelNavigationModal from "./MultiLevelNavigationModal.vue";

//#region General
type ViewModel = { baseCatalog: BaseCatalog | null };

export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogNodePathSelectionModal',
  props: {
    value: { type: Boolean },
    selectedEntryId: {},
    selectedPath: {}
  },
  emits: ["confirm", "input", "cancel", "close", "hide"],
  setup(__props: any, { emit: emits }) {

const props = __props;




//#endregion

//#region Store
const { primaryLanguageCode } = useContentLanguages();
//#endregion

//#region Viewmodel
const vm = reactive<ViewModel>({ baseCatalog: null });
//#endregion

//#region EventHandler
const onConfirm = (event: MultiLevelNavigationConfirmModel) => {
  emits("confirm", event);
};
//#endregion

//#region localValue
const localValue = computed({
  get: () => props.value,
  set: (nv) => emits("input", nv)
});

//#endregion

//#region FetchMethods

const getCatalogNodes = async (id: string | null | undefined): Promise<Branch[]> => {
  if (!vm.baseCatalog) vm.baseCatalog = await catalogsApi.getBaseCatalog({ language: primaryLanguageCode.value });
  let result: Branch[] = [];
  let fetched: { catalogNodes: CatalogNode[]; foundCatalogNodeCount: number } = { catalogNodes: [], foundCatalogNodeCount: 0 };
  if (vm.baseCatalog) {
    if (id) {
      fetched = await catalogsApi.getNodes({
        catalogId: vm.baseCatalog.catalogId,
        language: primaryLanguageCode.value,
        catalogNodeId: id
      });
    } else {
      fetched = await catalogsApi.getRootNodes({
        catalogId: vm.baseCatalog.catalogId,
        language: primaryLanguageCode.value
      });
    }
    result = fetched.catalogNodes.map((x) => ({
      id: x.catalogNodeId,
      name: x.nodeName,
      parentId: x.rootCatalogNode.id,
      depth: 0,
      hasNoChildren: x.catalogNodeType != "CatalogGroup",
      icon: x.catalogNodeType == "CatalogGroup" ? "CatalogGroup" : "VariantGroups"
    }));
  }
  return result;
};

const noLeaves = async (): Promise<Leaf[]> => {
  return [];
};
//#endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MultiLevelNavigationModal, {
    modelValue: localValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
    "modal-title": _ctx.$t('selectCatalogNodePath'),
    "fetch-branches": getCatalogNodes,
    "fetch-leaves": noLeaves,
    "selectable-type": ['branch'],
    "base-path-title": _ctx.$t('BaseCatalog'),
    onConfirm: onConfirm,
    "selected-entry-id": _ctx.selectedEntryId,
    "selected-path": _ctx.selectedPath,
    onHide: _cache[1] || (_cache[1] = ($event: any) => (emits('hide'))),
    onCancel: _cache[2] || (_cache[2] = ($event: any) => (emits('cancel'))),
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emits('close')))
  }, null, 8, ["modelValue", "modal-title", "base-path-title", "selected-entry-id", "selected-path"]))
}
}

})